export default {
  // Common
  common: {
    welcome: 'Willkommen',
    logout: 'Abmelden',
    users: 'Benutzer',
    order: 'Auftrag',
    orders: 'Aufträge',
    orderCount: '{{count}} Auftrag(e)',
    comingSoon: 'Diese Seite wird bald verfügbar sein',
    shipments: 'Lieferungen',
    fleet: 'Flotte',
    languageUpdateError: 'Fehler beim Aktualisieren der Sprache',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    create: 'Erstellen',
    search: 'Suchen',
    filter: 'Filtern',
    reset: 'Zurücksetzen',
    resetFilters: 'Filter zurücksetzen',
    back: 'Zurück',
    next: 'Weiter',
    contents: 'Inhalt',
    previous: 'Vorherige',
    submit: 'Absenden',
    confirm: 'Bestätigen',
    close: 'Schließen',
    loading: 'Lädt...',
    error: 'Fehler',
    success: 'Erfolg',
    yes: 'Ja',
    no: 'Nein',
    optional: 'Optional',
    required: 'Erforderlich',
    dashboard: 'Dashboard',
    settings: 'Einstellungen',
    view: 'Ansehen',
    download: 'Herunterladen',
    actions: 'Aktionen',
    details: 'Details',
    noData: 'Keine Daten verfügbar',
    weight: 'Gewicht',
    weightUnit: 'kg',
    pallets: 'Paletten',
    price: 'Preis',
    priceUnit: '€',
    contact: 'Kontakt',
    phone: 'Telefon',
    email: 'E-Mail',
    address: 'Adresse',
    publish: 'Veröffentlichen',
    follow: 'Folgen',
    accept: 'Akzeptieren',
    decline: 'Ablehnen',
    accepting: 'Akzeptieren...',
    declining: 'Ablehnen...',
    confirming: 'Bestätigen...',
    all: 'Alle',
    active: 'Aktiv',
    pending: 'Ausstehend',
    completed: 'Abgeschlossen',
    pickup: 'Abholung',
    delivery: 'Lieferung',
    route: 'Route',
    date: 'Datum',
    time: 'Zeit',
    status: 'Status',
    cargo: 'Fracht',
    trailer: 'Anhänger',
    driver: 'Fahrer',
    vehicle: 'Fahrzeug',
    company: 'Firma',
    name: 'Name',
    firstName: 'Vorname',
    lastName: 'Nachname',
    description: 'Beschreibung',
    instructions: 'Anweisungen',
    notes: 'Notizen',
    message: 'Nachricht',
    amount: 'Betrag',
    shipper: 'Versender',
    transporter: 'Spediteur',
    admin: 'Administrator',
  },

  // Auth
  auth: {
    welcomeTitle: 'Willkommen bei Velox',
    login: {
      title: 'Anmelden',
      subtitle: 'Melden Sie sich an oder erstellen Sie ein Konto, um Ihre TMS-Plattform zu nutzen',
      email: 'E-Mail',
      password: 'Passwort',
      forgotPassword: 'Passwort vergessen?',
      submit: 'Einloggen',
      loading: 'Einloggen...',
      success: 'Erfolgreich angemeldet!',
      error: 'Falsche Zugangsdaten',
      fillAllFields: 'Bitte alle Felder ausfüllen',
    },
    signup: {
      title: 'Registrieren',
      email: 'E-Mail',
      password: 'Passwort',
      confirmPassword: 'Passwort bestätigen',
      firstName: 'Vorname',
      lastName: 'Nachname',
      phone: 'Telefon',
      companyName: 'Firmenname',
      companyType: 'Typ',
      shipper: 'Versender',
      transporter: 'Transportunternehmer',
      registrationNumber: 'Steuer-ID',
      registrationNumberPlaceholder: 'z.B. USt-IdNr, Steuernr...',
      registrationNumberVerifying: 'Überprüfung läuft...',
      registrationNumberValid: '✓ Gültige Nummer',
      registrationNumberInvalid: '✗ Ungültige Nummer',
      registrationNumberExists: '⚠️ Dieses Unternehmen ist bereits registriert',
      countryCode: 'Land',
      countryCodePlaceholder: 'FR',
      verified: 'Verifiziert',
      alreadyExists: 'Bereits registriert',
      verifying: 'Überprüfung...',
      iban: 'IBAN',
      ibanPlaceholder: 'DE89 3704 0044 0532 0130 00',
      ibanRequired: 'IBAN ist erforderlich',
      foundedDate: 'Gründungsdatum des Unternehmens',
      foundedDateRequired: 'Das Gründungsdatum des Unternehmens ist erforderlich',
      acceptTerms: 'Ich akzeptiere die Allgemeinen Geschäftsbedingungen und die Datenschutzerklärung',
      acceptTermsPart1: 'Ich akzeptiere die',
      termsLink: 'Allgemeinen Geschäftsbedingungen',
      acceptTermsPart2: 'und die',
      privacyLink: 'Datenschutzerklärung',
      termsRequired: 'Sie müssen die AGB akzeptieren',
      submit: 'Konto erstellen',
      loading: 'Erstellen...',
      success: 'Konto erfolgreich erstellt!',
      error: 'Fehler beim Erstellen des Kontos',
      fillRequired: 'Bitte alle Pflichtfelder ausfüllen',
      passwordMismatch: 'Passwörter stimmen nicht überein',
      passwordLength: 'Passwort muss mindestens 6 Zeichen lang sein',
    },
    resetPassword: {
      title: 'Passwort zurücksetzen',
      subtitle: 'Geben Sie Ihre E-Mail-Adresse ein, um einen Link zu erhalten',
      email: 'E-Mail',
      submit: 'Link senden',
      loading: 'Senden...',
      success: 'Zurücksetzungs-E-Mail gesendet!',
      error: 'Fehler beim Senden der E-Mail',
      backToLogin: 'Zurück zur Anmeldung',
      enterEmail: 'Bitte E-Mail-Adresse eingeben',
    },
    newPassword: {
      title: 'Neues Passwort',
      subtitle: 'Wählen Sie ein neues sicheres Passwort für Ihr Konto',
      password: 'Neues Passwort',
      confirmPassword: 'Passwort bestätigen',
      placeholder: '••••••••',
      submit: 'Passwort aktualisieren',
      loading: 'Aktualisierung...',
      success: 'Passwort erfolgreich aktualisiert',
      error: 'Fehler beim Aktualisieren des Passworts',
      mismatch: 'Passwörter stimmen nicht überein',
      tooShort: 'Das Passwort muss mindestens 8 Zeichen lang sein',
      invalidToken: 'Dieser Reset-Link ist ungültig oder abgelaufen. Bitte fordern Sie einen neuen an.',
      invalidTokenTitle: 'Ungültiger Link',
      backToLogin: 'Zurück zur Anmeldung',
    },
  },

  // Dashboard
  dashboard: {
    header: {
      shipper: 'Versender-Dashboard',
      transporter: 'Transportunternehmer-Dashboard',
      driver: 'Meine Missionen',
      admin: 'Admin-Panel',
    },
    stats: {
      totalOrders: 'Gesamtaufträge',
      activeOrders: 'Aktive Aufträge',
      activeOrdersLabel: 'In Bearbeitung',
      draftOrders: 'Entwürfe',
      deliveredOrders: 'Geliefert',
      pendingBids: 'Ausstehende Angebote',
      completedOrders: 'Abgeschlossene Aufträge',
      totalRevenue: 'Gesamter Umsatz',
      activeDrivers: 'Aktive Fahrer',
      availableDrivers: 'Verfügbare Fahrer',
      availableVehicles: 'Verfügbare Fahrzeuge',
      ongoingMissions: 'Laufende Missionen',
      activeMissions: 'Aktive Missionen',
      completedMissions: 'Abgeschlossene Missionen',
      assignedMissions: 'Zugewiesen',
      totalTransporters: 'Gesamttransportunternehmer',
      totalDrivers: 'Gesamtfahrer',
      totalCommands: 'Gesamtaufträge',
      unpaidPayments: 'Ausstehende Zahlungen',
    },
    emptyState: {
      noOrders: 'Noch keine Aufträge',
      noOrdersInProgress: 'Noch keine laufenden Aufträge',
      noActiveMissions: 'Keine aktiven Missionen',
      noMissions: 'Noch keine Missionen',
      noAssignedMissions: 'Keine zugewiesenen Missionen',
      noCompletedMissions: 'Keine abgeschlossenen Missionen',
      noBids: 'Noch keine Angebote',
      noInProgress: 'Noch keine laufenden Aufträge',
      viewAllOrders: 'Alle meine Aufträge ansehen',
    },
    pendingReservations: {
      title: 'Ausstehende Reservierungen',
      subtitle: '{{count}} Transportunternehmer haben Ihre Aufträge gebucht',
      subtitles: ' hat',
      subtitlep: ' haben',
    },
    ordersInProgress: {
      title: 'Aufträge in Bearbeitung',
      subtitle: 'Ihre zugewiesenen und laufenden Aufträge',
    },
    activeMissions: {
      title: 'Aktive Missionen',
      noMissions: 'Keine aktiven Missionen',
      consultMarketplace: 'Besuchen Sie den Marketplace, um Missionen zu buchen',
    },
    createOrder: 'Auftrag erstellen',
  },

  // Orders
  orders: {
    title: 'Meine Aufträge',
    noCoordinates: 'Fehlende Koordinaten',
    print: {
      title: 'Bestellformular',
      button: 'Herunterladen',
      printButton: 'Drucken',
      generating: 'Wird generiert...',
      printing: 'Drucken...',
      success: 'Bild generiert',
      downloaded: 'Bestellformular erfolgreich heruntergeladen',
      error: 'Fehler',
      elementNotFound: 'Inhalt zum Erfassen nicht gefunden',
      generationFailed: 'Fehler beim Generieren des Bildes',
      qrNotGenerated: 'QR-Code nicht generiert',
      pickupInfo: '📦 Abholinformationen',
      deliveryInfo: '🚚 Lieferinformationen',
      cargoInfo: '📋 Fracht',
      additionalInstructions: '⚠️ Zusätzliche Anweisungen',
      notSpecified: 'Nicht angegeben',
      title_field: 'Titel:',
      vehicleType: 'Fahrzeugtyp:',
      volume: 'Volumen:',
      platformDescription: 'VELOX - Logistik-Management-Plattform',
      generatedOn: 'Dokument erstellt am',
    },
    subtitle: 'Verwalten Sie alle Ihre Aufträge nach Status',
    create: 'Auftrag erstellen',
    createNew: '+ Auftrag erstellen',
    filterByStatus: 'Nach Status filtern',
    filterDescription: 'Wählen Sie einen Status, um passende Aufträge anzuzeigen',
    selectStatus: 'Status wählen',
    orderNumber: 'Auftragsnummer',
    statuses: {
      all: 'Alle',
      draft: 'Entwurf',
      posted: 'Veröffentlicht',
      booked: 'Gebucht',
      assigned: 'Zugewiesen',
      in_transit: 'In Transit',
      delivered: 'Geliefert',
      cancelled: 'Storniert',
      drafts: 'Entwürfe',
      posted_plural: 'Veröffentlicht',
      booked_plural: 'Gebucht',
      assigned_plural: 'Zugewiesen',
      in_transit_plural: 'In Transit',
      delivered_plural: 'Geliefert',
      cancelled_plural: 'Storniert',
    },
    statusDescriptions: {
      draft: 'Auftrag in Erstellung',
      posted: 'Auftrag auf Marketplace veröffentlicht',
      booked: 'Anfrage akzeptiert, wartet auf Fahrer-/Fahrzeugzuweisung',
      assigned: 'Fahrer und Fahrzeug zugewiesen',
      in_transit: 'Auftrag in Transit',
      delivered: 'Auftrag erfolgreich geliefert',
      cancelled: 'Auftrag storniert',
    },
    status: {
      draft: 'Entwurf',
      posted: 'Veröffentlicht',
      booked: 'Gebucht',
      assigned: 'Zugewiesen',
      inTransit: 'In Transit',
      delivered: 'Geliefert',
      cancelled: 'Storniert',
    },
    statusLabels: {
      pending: 'Ausstehend',
      accepted: 'Akzeptiert',
      assigned: 'Zugewiesen',
    },
    emptyStates: {
      all: 'Noch keine Aufträge',
      draft: 'Keine Entwürfe',
      posted: 'Keine veröffentlichten Aufträge',
      booked: 'Keine gebuchten Aufträge',
      assigned: 'Keine zugewiesenen Aufträge',
      in_transit: 'Keine Aufträge in Transit',
      delivered: 'Keine gelieferten Aufträge',
      cancelled: 'Keine stornierten Aufträge',
    },
    priceValidated: 'Preis bestätigt',
    priceProposed: 'Vorgeschlagener Preis',
    myOffers: 'Meine Angebote',
    reservationPending: 'Reservierung ausstehend',
    confirmation: 'Bestätigung',
    refusal: 'Ablehnung',
    yourPreviousOfferDeclined: 'Ihr vorheriges Angebot wurde abgelehnt',
    declinedOn: 'Abgelehnt am',
    yourPendingOffer: 'Ihr ausstehendes Angebot',
    proposedAmount: 'Vorgeschlagener Betrag',
    submittedOn: 'Eingereicht am',
    bookFixedPrice: 'Zum Fixpreis buchen',
    makeOffer: 'Angebot abgeben',
    makeNewOffer: 'Neues Angebot abgeben',
    offerPendingResponse: 'Angebot ausstehend',
    cancel: 'Abbrechen',
    confirmCancel: 'Möchten Sie die Mission {{orderNumber}} wirklich stornieren?',
    cancelSuccess: 'Mission erfolgreich storniert',
    cancelError: 'Fehler bei der Stornierung der Mission',
    transporter: 'Transportunternehmer',
    statusLabel: 'Status',
    pickupDate: 'Abholdatum',
    pickupLocation: 'Abholort',
    deliveryDate: 'Lieferdatum',
    deliveryLocation: 'Lieferort',
    weight: 'Gewicht',
    price: 'Preis',
    trailerType: 'Anhängertyp',
    form: {
      title: 'Auftrag erstellen',
      subtitle: 'Geben Sie Ihre Transportdetails ein',
      priceRequired: 'Vorgeschlagener Preis erforderlich, um den Auftrag zu veröffentlichen',
    },
    card: {
      order: 'Auftrag',
      validatedPrice: 'Bestätigter Preis',
      proposedPrice: 'Vorgeschlagener Preis',
      weight: 'Gewicht',
      pallets: 'Paletten',
      boxes: 'Kisten',
      euroPallets: 'Euro-Paletten',
      publish: 'Veröffentlichen',
      myOffers: 'Meine Angebote',
      track: 'Verfolgen',
      details: 'Details',
    },
    details: {
      title: 'Vollständige Auftragsdetails',
      proposedPrice: 'Vorgeschlagener Preis',
      cargo: 'Fracht',
      cargoTitle: 'Titel:',
      cargoDescription: 'Beschreibung:',
      cargoImage: 'Frachtfoto',
      startImages: 'Abholfotos',
      deliveryImages: 'Lieferfotos',
      weight: 'Gewicht:',
      pallets: 'Paletten:',
      boxes: 'Kisten:',
      euroPallets: 'Euro-Paletten:',
      volume: 'Volumen:',
      type: 'Typ:',
      route: 'Route',
      pickup: 'Abholung:',
      delivery: 'Lieferung:',
      transporterInfo: 'Transportunternehmerinformationen',
      company: 'Firma',
      assignedDriver: 'Zugewiesener Fahrer',
      vehicle: 'Fahrzeug',
      plateNumber: 'Kennzeichen',
      licenseNumber: 'Führerschein',
      trailerType: 'Anhängertyp',
      specialInstructions: 'Spezialanweisungen',
      visibleMarketplace: '✓ Im Marketplace sichtbar',
      edit: 'Bearbeiten',
      print: 'Drucken',
      delete: 'Löschen',
      close: 'Schließen',
      confirmDelete: 'Löschung bestätigen',
      confirmDeleteText:
        'Sind Sie sicher, dass Sie den Auftrag {{orderNumber}} löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
      cancel: 'Abbrechen',
      deleteSuccess: 'Auftrag erfolgreich gelöscht',
      deleteError: 'Fehler beim Löschen des Auftrags',
    },
    messages: {
      publishedSuccess: 'Auftrag erfolgreich veröffentlicht!',
      publishError: 'Fehler bei der Veröffentlichung des Auftrags',
    },
  },

  // Bids
  bids: {
    title: 'Angebote',
    offersReceived: 'Eingegangene Angebote',
    offersReceivedCount: 'Eingegangene Angebote ({{count}})',
    viewBids: 'Angebote ansehen',
    noBids: 'Noch keine Angebote',
    noBidsReceived: 'Noch keine eingegangenen Angebote',
    newBid: 'Neues Angebot',
    amount: 'Betrag',
    proposedAmount: 'Vorgeschlagener Betrag',
    message: 'Nachricht',
    submit: 'Angebot absenden',
    accept: 'Akzeptieren',
    decline: 'Ablehnen',
    accepted: 'Akzeptiert',
    declined: 'Abgelehnt',
    pending: 'Ausstehend',
    receivedOn: 'Eingegangen am',
    orderDetails: 'Auftragsdetails',
    acceptBid: 'Akzeptieren',
    declineBid: 'Ablehnen',
  },

  // Marketplace
  marketplace: {
    title: 'Marktplatz',
    subtitle: 'Verfügbare Aufträge finden',
    filters: 'Filter',
    trailerType: 'Anhängertyp',
    allTypes: 'Alle Typen',
    departureCity: 'Abfahrtsstadt',
    departureCityPlaceholder: 'z.B. Berlin',
    arrivalCity: 'Ankunftsstadt',
    arrivalCityPlaceholder: 'z.B. München',
    availabilityDate: 'Verfügbarkeitsdatum',
    selectDate: 'Datum auswählen',
    sortByDistance: 'Nach Entfernung sortieren',
    noSort: 'Keine Sortierung',
    sortAsc: 'Nächste zuerst',
    sortDesc: 'Fernste zuerst',
    resetFilters: 'Filter zurücksetzen',
    searchOrders: 'Aufträge suchen...',
    sortBy: 'Sortieren nach',
    sortNewest: 'Neueste',
    sortPrice: 'Preis',
    sortDistance: 'Entfernung',
    noOrders: 'Keine verfügbaren Aufträge',
    loadMore: 'Mehr laden',
    pickupLocation: 'Abholort',
    deliveryLocation: 'Lieferort',
    weight: 'Gewicht',
    vehicleType: 'Fahrzeugtyp',
    price: 'Preis',
    messages: {
      applicationSent: 'Ihre Bewerbung wurde erfolgreich gesendet',
    },
    errors: {
      applicationError: 'Fehler beim Senden der Bewerbung',
    },
    card: {
      pickup: 'Abholung',
      delivery: 'Lieferung',
      weight: 'Gewicht:',
      pallets: 'Paletten:',
      declinedBid: 'Ihr vorheriges Angebot wurde abgelehnt',
      declinedAmount: 'Betrag:',
      declinedOn: 'Abgelehnt am',
      pendingBid: 'Ihr ausstehendes Angebot',
      proposedAmount: 'Vorgeschlagener Betrag',
      message: 'Nachricht',
      submittedOn: 'Eingereicht am',
      bookFixed: 'Zum Fixpreis buchen',
      bidPending: 'Angebot ausstehend',
      makeNewBid: 'Neues Angebot abgeben',
      makeBid: 'Angebot abgeben',
      applying: 'Wird gesendet...',
      applyForOrder: 'Für diesen Auftrag bewerben',
    },
    placeBid: 'Angebot abgeben',
    viewDetails: 'Details ansehen',
    bookOrder: 'Auftrag buchen',
    bookingSuccess: 'Mission erfolgreich gebucht',
    bookingError: 'Fehler bei der Buchung der Mission',
  },

  // Fleet
  fleet: {
    title: 'Flotten­verwaltung',
    subtitle: 'Verwalten Sie Ihre Fahrzeuge und Fahrer',
    vehicles: 'Fahrzeuge',
    drivers: 'Fahrer',
    wizard: {
      step1: 'Schritt 1: Fahrzeugtyp',
      step2: 'Schritt 2: Fahrzeugschein Fotos',
      step3: 'Schritt 3: Fahrzeuginformationen',
      step1Description: 'Fahrzeugtyp auswählen',
      step2Description: 'Fotos hochladen (optional)',
      step3Description: 'Informationen vervollständigen',
    },
    extraction: {
      analyzing: 'Analysiere...',
      analyzingFront: 'Analysiere Vorderseite...',
      analyzingBack: 'Analysiere Rückseite...',
      success: 'Daten erfolgreich extrahiert',
      frontComplete: 'Vorderseite analysiert',
      backComplete: 'Rückseite analysiert',
      successDesc: 'Fahrzeuginformationen wurden automatisch ausgefüllt',
      error: 'Extraktionsfehler',
      errorDesc: 'Daten konnten nicht extrahiert werden. Bitte manuell ausfüllen.',
      step1: 'Schritt 1/2: Vorderseite',
      step2: 'Schritt 2/2: Rückseite',
      optional: 'Optionale Fotos:',
      optionalDesc: 'Sie können Fotos des Fahrzeugscheins aufnehmen, um die Felder automatisch auszufüllen, oder die Informationen manuell eingeben.',
      notRegistrationCard: 'Dokument nicht erkannt',
      notRegistrationCardDesc: 'Dieses Bild scheint kein Fahrzeugschein zu sein. Bitte machen Sie ein klares Foto eines gültigen Fahrzeugscheins.',
    },
    dialogs: {
      addVehicle: 'Fahrzeug hinzufügen',
      editVehicle: 'Fahrzeug bearbeiten',
      captureRegistration: 'Fahrzeugschein Fotografieren',
      captureRegistrationFront: 'Fahrzeugschein - Vorderseite',
      captureRegistrationBack: 'Fahrzeugschein - Rückseite',
      inviteDriver: 'Fahrer einladen',
      editDriver: 'Fahrer bearbeiten',
      vehicleType: 'Fahrzeugtyp',
      plateNumber: 'Kennzeichen',
      plateNumberPlaceholder: 'z.B. AB-123-CD',
      vin: 'Fahrgestellnummer (VIN)',
      vinPlaceholder: 'z.B. 1HGBH41JXMN109186',
      brand: 'Marke',
      brandPlaceholder: 'z.B. Mercedes-Benz',
      model: 'Modell',
      modelPlaceholder: 'z.B. Sprinter',
      year: 'Baujahr',
      yearPlaceholder: 'z.B. 2020',
      lastMaintenance: 'Letzte Wartung',
      lastMaintenancePlaceholder: 'Datum auswählen',
      nextMaintenance: 'Nächste Wartung',
      nextMaintenancePlaceholder: 'Datum auswählen',
      status: 'Status',
      email: 'E-Mail',
      firstName: 'Vorname',
      lastName: 'Nachname',
      phone: 'Telefon',
      licenseNumber: 'Führerscheinnummer',
      licenseExpiry: 'Führerschein Ablaufdatum',
      select: 'Auswählen',
      selectType: 'Typ wählen',
      selectVehicleType: 'Typ auswählen',
      required: '*',
      cancel: 'Abbrechen',
      add: 'Hinzufügen',
      addingVehicle: 'Fahrzeug wird hinzugefügt...',
      save: 'Speichern',
      sendInvitation: 'Einladung senden',
      statusAvailable: 'Verfügbar',
      statusOnMission: 'Auf Mission',
      statusOffDuty: 'Außer Dienst',
    },
    invitations: 'Einladungen',
    myVehicles: 'Meine Fahrzeuge',
    myDrivers: 'Meine Fahrer',
    addVehicle: 'Fahrzeug hinzufügen',
    addDriver: '+ Fahrer einladen',
    inviteDriver: 'Fahrer einladen',
    addFirstVehicle: 'Fügen Sie Ihr erstes Fahrzeug hinzu',
    inviteFirstDriver: 'Laden Sie Ihren ersten Fahrer ein',
    noVehicles: 'Keine Fahrzeuge registriert',
    noDrivers: 'Keine Fahrer registriert',
    noInvitations: 'Keine Einladungen',
    pendingInvitations: 'Ausstehende Einladungen',
    activeDrivers: 'Aktive Fahrer',
    vehicleDetails: {
      brand: 'Marke',
      model: 'Modell',
      year: 'Baujahr',
      plateNumber: 'Kennzeichen',
      type: 'Typ',
      status: 'Status',
      available: 'Verfügbar',
      unavailable: 'Nicht verfügbar',
      inUse: 'In Gebrauch',
      onMission: 'Auf Mission',
      maintenance: 'Wartung',
      lastMaintenance: 'Letzte Wartung',
      nextMaintenance: 'Nächste Wartung',
      vin: 'VIN:',
      modelLabel: 'Modell:',
      nextMaintenanceLabel: 'Nächste Wartung:',
    },
    driverDetails: {
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      license: 'Führerschein',
      licenseNumber: 'Führerscheinnummer',
      licenseExpiry: 'Führerschein Ablaufdatum',
      status: 'Status',
      available: 'Verfügbar',
      onMission: 'Auf Mission',
      offDuty: 'Außer Dienst',
      unavailable: 'Nicht verfügbar',
      noName: 'Fahrer ohne Namen',
      licenseExpiresOn: 'Führerschein läuft ab am',
      position: 'Position',
      positionUnavailable: 'Position nicht verfügbar',
      addedOn: 'Hinzugefügt am',
    },
    invitationDetails: {
      email: 'E-Mail',
      phone: 'Telefon',
      pending: 'Ausstehend',
      expired: 'Abgelaufen',
      expires: 'Läuft ab',
      sentOn: 'Einladung gesendet am',
    },
    cancelInvitation: 'Einladung stornieren',
    cancelInvitationTitle: 'Einladung stornieren',
    cancelInvitationDescription: 'Sind Sie sicher, dass Sie die Einladung von {{name}} ({{email}}) stornieren möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    confirmCancel: 'Ja, stornieren',
    invitationDeleted: 'Einladung storniert',
    invitationDeletedDescription: 'Die Einladung wurde erfolgreich gelöscht',
    invitationDeleteError: 'Einladung kann nicht gelöscht werden',
    resendEmail: 'E-Mail erneut senden',
    emailResent: 'E-Mail erneut gesendet',
    emailResentDescription: 'Die Einladungs-E-Mail wurde erneut an {{email}} gesendet',
    actions: {
      edit: 'Bearbeiten',
      delete: 'Löschen',
      cancel: 'Abbrechen',
    },
    deleteDialog: {
      vehicleTitle: 'Fahrzeug löschen',
      vehicleDescription: 'Sind Sie sicher, dass Sie das Fahrzeug löschen möchten',
      driverTitle: 'Fahrer löschen',
      driverDescription: 'Sind Sie sicher, dass Sie den Fahrer löschen möchten',
      irreversible: 'Diese Aktion kann nicht rückgängig gemacht werden.',
    },
    documentStatus: {
      verified: 'Verifiziert',
      unverified: 'Nicht verifiziert',
      expired: 'Abgelaufen',
      expiringSoon: 'Läuft bald ab',
      registrationCard: 'Fahrzeugschein',
      driverLicense: 'Führerschein',
      scanRegistration: 'Fahrzeugschein scannen',
      scanLicense: 'Führerschein scannen',
      rescan: 'Erneut scannen',
      lockedField: 'Gesperrt (per OCR verifiziert)',
    },
    license: {
      title: 'Führerschein-Verifizierung',
      howTo: 'So geht\'s:',
      howToDesc: 'Fotografieren Sie Vorder- und Rückseite des Führerscheins. Die Daten werden extrahiert und automatisch gesperrt.',
      front: 'Vorderseite',
      back: 'Rückseite',
      captureFront: 'Vorderseite aufnehmen',
      captureBack: 'Rückseite aufnehmen',
      frontDone: 'Vorderseite analysiert',
      backDone: 'Rückseite analysiert',
      extracted: 'Daten extrahiert',
      extractedData: 'Führerscheindaten',
      lockedNotice: 'Diese Felder werden gesperrt und können nicht manuell bearbeitet werden.',
      categories: 'Klassen',
      save: 'Führerschein speichern',
      saved: 'Führerschein gespeichert',
      savedDesc: 'Der Führerschein wurde verifiziert und gespeichert.',
      incomplete: 'Unvollständige Daten',
      incompleteDesc: 'Nummer und Ablaufdatum sind erforderlich.',
      notALicense: 'Dokument nicht erkannt',
      notALicenseDesc: 'Dieses Bild scheint kein Führerschein zu sein. Bitte machen Sie ein klares Foto eines gültigen Führerscheins.',
    },
  },

  // Missions
  missions: {
    title: 'Meine Missionen',
    myMissions: 'Meine Missionen',
    subtitle: 'Verwalten Sie Ihre Transportmissionen',
    all: 'Alle',
    pending: 'Ausstehend',
    upcoming: 'Bevorstehend',
    ongoing: 'Laufend',
    active: 'Aktiv',
    completed: 'Abgeschlossen',
    assigned: 'Zugewiesen',
    search: 'Nach Nummer, Stadt oder Adresse suchen...',
    noResults: 'Keine Missionen entsprechen Ihrer Suche',
    resultFound: 'Ergebnis gefunden',
    resultsFound: 'Ergebnisse gefunden',
    noMissions: 'Keine Missionen',
    noMissionPending: 'Keine ausstehenden Missionen',
    noMissionActive: 'Keine aktiven Missionen',
    noMissionCompleted: 'Keine abgeschlossenen Missionen',
    filters: {
      title: 'Filter',
      trailerType: 'Anhängertyp',
      distance: 'Entfernung',
      allTrailers: 'Alle Typen',
      allDistances: 'Alle Entfernungen',
      distance0to100: 'Weniger als 100 km',
      distance100to500: '100 - 500 km',
      distance500to1000: '500 - 1000 km',
      distance1000plus: 'Mehr als 1000 km',
      clearFilters: 'Filter zurücksetzen',
    },
    assignDriver: 'Fahrer zuweisen',
    assignVehicle: 'Fahrzeug zuweisen',
    startMission: 'Mission starten',
    completeMission: 'Mission abschließen',
    orderNumber: 'Auftragsnummer',
    pickup: 'Abholung',
    delivery: 'Lieferung',
    status: 'Status',
    accept: 'Akzeptieren',
    decline: 'Ablehnen',
    scanQR: 'QR scannen',
    openDocuments: 'Dokumente',
    uploadPOD: 'POD hochladen',
    reportDelay: 'Verspätung melden',
    actions: {
      assign: 'Zuweisen',
      viewDetails: 'Details ansehen',
      accept: 'Akzeptieren',
      decline: 'Ablehnen',
      refuse: 'Ablehnen',
      scanQR: 'QR scannen',
      documents: 'Dokumente',
      viewDocuments: 'Dokumente ansehen',
      reportDelay: 'Verspätung melden',
      route: 'Route',
    },
    history: 'Historie',
    inProgress: 'In Bearbeitung',
    card: {
      orderNumber: 'Auftrag Nr.',
      from: 'Von',
      to: 'Nach',
      order: 'Auftrag',
      weight: 'Gewicht',
      type: 'Typ',
      price: 'Preis',
      driver: 'Fahrer:',
      vehicle: 'Fahrzeug:',
      assign: 'Zuweisen',
      pickup: 'Abholung',
      delivery: 'Lieferung',
      cargo: 'Fracht',
      notAssigned: 'Nicht zugewiesen',
      assignDriver: 'Fahrer zuweisen',
      delayReported: 'Verspätung gemeldet',
      status: {
        completed: 'Abgeschlossen',
        inProgress: 'In Bearbeitung',
        assigned: 'Zugewiesen',
        pending: 'Ausstehend',
      },
    },
    empty: {
      assigned: 'Keine zugewiesenen Missionen',
      active: 'Keine aktiven Missionen',
      completed: 'Keine abgeschlossenen Missionen',
    },
  },

  // Billing
  billing: {
    title: 'Abrechnung',
    detailsTitle: 'Details',
    subtitle: 'Verwalten Sie Ihre Bestellungen und Rechnungen',
    filterByStatus: 'Nach Status filtern',
    allStatuses: 'Alle Status',
    documentType: 'Dokumenttyp',
    documentNumber: 'Nummer',
    amount: 'Betrag ohne MwSt.',
    vatRate: 'MwSt.-Satz',
    vatAmount: 'MwSt.-Betrag',
    totalAmount: 'Gesamtbetrag inkl. MwSt.',
    issueDate: 'Ausstellungsdatum',
    dueDate: 'Fälligkeitsdatum',
    paidDate: 'Zahlungsdatum',
    types: {
      order_form: 'Bestellformular',
      invoice: 'Rechnung',
    },
    stats: {
      title: 'Übersicht',
      totalInvoiced: 'Gesamt abgerechnet',
      totalPaid: 'Gesamt bezahlt',
      totalPending: 'Ausstehend',
      paymentProgress: 'Zahlungsfortschritt',
    },
    statuses: {
      draft: 'Entwurf',
      sent: 'Gesendet',
      paid: 'Bezahlt',
      cancelled: 'Storniert',
    },
    tabs: {
      orderForms: 'Bestellformulare',
      invoices: 'Rechnungen',
    },
    emptyStates: {
      orderForms: {
        title: 'Keine Bestellformulare',
        description: 'Bestellformulare erscheinen hier, sobald sie erstellt wurden.',
      },
      invoices: {
        title: 'Keine Rechnungen',
        description: 'Rechnungen erscheinen hier, sobald sie erstellt wurden.',
      },
    },
    messages: {
      pdfSuccess: 'PDF erfolgreich heruntergeladen',
      pdfError: 'Fehler bei der PDF-Erstellung',
      markedAsPaid: 'Dokument als bezahlt markiert',
      titleRequired: 'Der Titel darf nicht leer sein',
      titleUpdated: 'Titel erfolgreich aktualisiert',
    },
    status: {
      paid: 'Bezahlt',
      sent: 'Gesendet',
      cancelled: 'Storniert',
      draft: 'Entwurf',
    },
    documentTypes: {
      orderForm: 'Bestellformular',
      invoice: 'Rechnung',
    },
    card: {
      order: 'Auftrag:',
      route: 'Route:',
      amountHT: 'Betrag (exkl. USt)',
      vat: 'USt',
      totalTTC: 'Gesamt (inkl. USt)',
      issuedOn: 'Ausgestellt am:',
      dueDate: 'Fälligkeitsdatum:',
      paidOn: 'Bezahlt am:',
      view: 'Ansehen',
      pdf: 'PDF',
    },
    dialog: {
      documentNumber: 'Dokumentnummer',
      customTitle: 'Benutzerdefinierter Titel',
      noTitle: 'Kein Titel',
      titlePlaceholder: 'Geben Sie einen Titel für dieses Dokument ein',
      shipper: 'Versender',
      transporter: 'Transportunternehmer',
      orderDetails: 'Auftragsdetails',
      orderNumber: 'Auftragsnummer:',
      cargo: 'Fracht:',
      route: 'Route:',
      financialDetails: 'Finanzielle Details',
      amountHT: 'Betrag (exkl. USt)',
      vat: 'USt',
      totalTTC: 'Gesamt (inkl. USt)',
      importantDates: 'Wichtige Daten',
      issueDate: 'Ausstellungsdatum',
      dueDate: 'Fälligkeitsdatum',
      paymentDate: 'Zahlungsdatum',
      notes: 'Notizen',
      markAsPaid: 'Als bezahlt markieren',
      downloadPDF: 'PDF herunterladen',
    },
    orderForms: 'Bestellformulare',
    invoices: 'Rechnungen',
    noDocuments: 'Keine Dokumente',
    date: 'Datum',
    paid: 'Bezahlt',
    unpaid: 'Unbezahlt',
    overdue: 'Überfällig',
    markAsPaid: 'Als bezahlt markieren',
    viewDocument: 'Dokument ansehen',
    downloadPDF: 'PDF herunterladen',
    details: {
      shipper: 'Versender',
      transporter: 'Transportunternehmer',
      orderDetails: 'Auftragsdetails',
      route: 'Route',
      cargo: 'Fracht',
      financial: 'Finanzübersicht',
      subtotal: 'Zwischensumme',
      vat: 'USt',
      total: 'Gesamt (inkl. USt)',
      createdAt: 'Erstellt am',
      dueDate: 'Fälligkeitsdatum',
      paidAt: 'Bezahlt am',
    },
  },

  // Notifications
  notifications: {
    title: 'Benachrichtigungen',
    markAllRead: 'Alle als gelesen markieren',
    markAll: 'Alle markieren',
    noNotifications: 'Keine Benachrichtigungen',
    empty: 'Keine Benachrichtigungen',
    markAsReadError: 'Fehler beim Markieren der Benachrichtigung',
    markAllAsReadError: 'Fehler beim Markieren aller Benachrichtigungen',
    allMarkedAsRead: 'Alle Benachrichtigungen als gelesen markiert',
    notificationNotFound: 'Diese Bestellung konnte nicht gefunden werden',
    types: {
      mission_assigned: 'Mission zugewiesen',
      new_bid: 'Neues Angebot',
      bid_accepted: 'Angebot akzeptiert',
      bid_declined: 'Angebot abgelehnt',
      order_updated: 'Auftrag aktualisiert',
      mission_started: 'Mission gestartet',
      mission_completed: 'Mission abgeschlossen',
      payment_received: 'Zahlung erhalten',
      rating_reminder: 'Bewertungserinnerung',
    },
  },

  // Navigation
  nav: {
    dashboard: 'Dashboard',
    marketplace: 'Marktplatz',
    missions: 'Missionen',
    liveMap: 'Live-Karte',
    myMissions: 'Meine Missionen',
    myOrders: 'Meine Aufträge',
    fleet: 'Flotte',
    billing: 'Abrechnung',
    settings: 'Einstellungen',
    logout: 'Abmelden',
  },

  // Tracking
  liveMap: {
    description: 'Verfolgen Sie alle Ihre aktiven Missionen in Echtzeit',
    noActiveMissions: 'Derzeit keine aktiven Missionen',
    filters: 'Filter',
    searchPlaceholder: 'Nach Bestellnummer suchen...',
    noResults: 'Keine Missionen entsprechen den Filtern',
    dateFilter: 'Zeitraum',
    allOrders: 'Alle Bestellungen',
    today: 'Heute',
    last7Days: 'Letzte 7 Tage',
    last30Days: 'Letzte 30 Tage',
    last90Days: 'Letzte 90 Tage',
    last365Days: 'Letzte 365 Tage',
  },

  tracking: {
    title: 'Auftragsverfolgung',
    orderNotFound: 'Auftrag nicht gefunden',
    returnToDashboard: 'Zurück zum Dashboard',
    deliveryDocuments: 'Lieferdokumente',
    trackingHistory: 'Verlauf verfolgen',
    trackingMap: 'Verfolgungskarte',
    noEvents: 'Noch keine Verfolgungsereignisse',
    interactiveMap: 'Interaktive Karte',
    noCoordinates: 'GPS-Koordinaten für diese Bestellung nicht verfügbar',
    events: {
      pickup_confirmed: 'Abholung bestätigt',
      in_transit: 'In Transit',
      delivered: 'Geliefert',
      exception: 'Ausnahme',
    },
  },

  // Settings
  settings: {
    companyDocuments: {
      title: 'Von Velox hinzugefügte Dokumente',
      description: 'Dokumente, die das Velox-Team Ihrem Unternehmen zugeordnet hat.',
      empty: 'Es wurde noch kein Dokument hinzugefügt.',
    },
    title: 'Einstellungen',
    subtitle: 'Verwalten Sie Ihre persönlichen Informationen und Ihr Konto',
    tabs: {
      profile: 'Profil',
      company: 'Unternehmen',
      language: 'Sprache',
      email: 'E-Mail',
      password: 'Passwort',
      notifications: 'Benachrichtigungen',
    },
    profile: {
      title: 'Persönliche Informationen',
      description: 'Aktualisieren Sie Ihre persönlichen Daten',
      firstName: 'Vorname',
      lastName: 'Nachname',
      phone: 'Telefon',
      save: 'Änderungen speichern',
      companyLogo: 'Firmenlogo',
      profilePhoto: 'Profilbild',
      changeImage: 'Bild ändern',
      imageHint: 'JPG, PNG oder WebP. Max 2 MB.',
      imageUploadSuccess: 'Bild erfolgreich aktualisiert',
      imageUploadError: 'Fehler beim Hochladen des Bildes',
      imageTypeError: 'Format nicht unterstützt. Verwenden Sie JPG, PNG oder WebP.',
      imageSizeError: 'Datei ist zu groß. Maximal 2 MB.',
    },
    company: {
      title: 'Unternehmensinformationen',
      description: 'Verwalten Sie Ihre Unternehmensdaten',
      name: 'Unternehmensname',
      registrationNumber: 'Steueridentifikationsnummer',
      registrationNumberDescription: 'SIRET, USt-IdNr oder andere Steuernummer je nach Land',
      iban: 'IBAN (optional)',
      ibanPlaceholder: 'DE89 3704 0044 0532 0130 00',
      ibanDescription: 'Wird für Zahlungen und Rechnungen verwendet. Sie können sie später hinzufügen.',
      ibanInvalid: 'Ungültige IBAN',
      address: 'Adresse',
      phone: 'Telefon',
      save: 'Änderungen speichern',
    },
    language: {
      title: 'Oberflächensprache',
      description: 'Wählen Sie Ihre bevorzugte Sprache',
      label: 'Sprache',
      note: 'Die Sprache wird auf die gesamte Oberfläche angewendet',
    },
    email: {
      title: 'E-Mail-Adresse',
      description: 'Ändern Sie Ihre Login-E-Mail-Adresse',
      newEmail: 'Neue E-Mail-Adresse',
      update: 'E-Mail aktualisieren',
      notifications: {
        label: 'E-Mail-Benachrichtigungen',
        description: 'Wichtige Benachrichtigungen per E-Mail erhalten',
      },
    },
    password: {
      title: 'Passwort',
      description: 'Ändern Sie Ihr Login-Passwort',
      currentPassword: 'Aktuelles Passwort',
      newPassword: 'Neues Passwort',
      confirmPassword: 'Passwort bestätigen',
      save: 'Passwort ändern',
    },
    notifications: {
      title: 'Benachrichtigungen',
      description: 'Verwalten Sie Ihre Benachrichtigungseinstellungen',
      emailLabel: 'E-Mail-Benachrichtigungen',
      emailDescription: 'Benachrichtigungen per E-Mail erhalten',
    },
    validation: {
      firstNameRequired: 'Vorname ist erforderlich',
      lastNameRequired: 'Nachname ist erforderlich',
      companyNameRequired: 'Unternehmensname ist erforderlich',
      maxLength: 'Maximal {{max}} Zeichen',
      emailInvalid: 'Ungültige E-Mail',
      passwordMin: 'Mindestens 6 Zeichen',
      passwordMismatch: 'Passwörter stimmen nicht überein',
    },
    messages: {
      profileUpdated: 'Profil erfolgreich aktualisiert',
      profileError: 'Fehler beim Aktualisieren des Profils',
      companyUpdated: 'Unternehmen erfolgreich aktualisiert',
      companyError: 'Fehler beim Aktualisieren des Unternehmens',
      emailSent: 'Bestätigungs-E-Mail gesendet',
      emailError: 'Fehler beim Aktualisieren der E-Mail',
      currentPasswordIncorrect: 'Aktuelles Passwort ist falsch',
      passwordUpdated: 'Passwort erfolgreich aktualisiert',
      passwordError: 'Fehler beim Aktualisieren des Passworts',
      languageUpdated: 'Sprache erfolgreich aktualisiert',
      languageError: 'Fehler beim Aktualisieren der Sprache',
      emailPreferencesUpdated: 'Benachrichtigungseinstellungen aktualisiert',
      notificationsUpdated: 'Benachrichtigungseinstellungen aktualisiert',
      notificationsError: 'Fehler beim Aktualisieren der Benachrichtigungen',
    },
  },

  // Vehicle Types (Trailer Types)
  vehicleTypes: {
    van: 'Kastenwagen',
    flatbed: 'Pritschenwagen',
    refrigerated: 'Kühlwagen',
    tanker: 'Tankwagen',
    curtainsider: 'Planenauflieger',
    lowloader: 'Tieflader',
    container: 'Containerauflieger',
    any: 'Beliebiger Typ',
    car: 'Autotransporter',
    van_small: 'Kleiner Transporter',
    utility: 'Nutzfahrzeug',
    other: 'Sonstiges',
  },

  // Admin
  admin: {
    title: 'Admin-Panel',
    unpaidPayments: 'Ausstehende Zahlungen',
    auditLogs: 'Audit-Logs',
    allPaid: 'Alle Zahlungen sind auf dem neuesten Stand',
    noPendingOrders: 'Keine offenen Zahlungen',
    transporter: 'Transportunternehmer',
    orders: 'Aufträge',
    totalAmount: 'Gesamtbetrag',
    action: 'Aktion',
    markPaid: 'Als bezahlt markieren',
    confirmPayment: 'Zahlung bestätigen',
    confirmPaymentText:
      'Sind Sie sicher, dass Sie {{count}} Auftrag(e) von {{name}} mit einem Gesamtbetrag von {{amount}} € als bezahlt markieren möchten?',
    recording: 'Aufzeichnung...',
    cancel: 'Abbrechen',
    filters: 'Filter',
    reset: 'Zurücksetzen',
    table: 'Tabelle',
    allTables: 'Alle Tabellen',
    allActions: 'Alle Aktionen',
    dateFrom: 'Startdatum',
    dateTo: 'Enddatum',
    noAuditLogs: 'Keine Audit-Logs gefunden',
    tryModifyFilters: 'Versuchen Sie, Ihre Filter anzupassen',
    logsWillAppear: 'Audit-Logs werden hier erscheinen',
    timestamp: 'Zeitstempel',
    user: 'Benutzer',
    details: 'Details',
    system: 'System',
    oldValues: 'Alte Werte',
    newValues: 'Neue Werte',
    clickToSee: 'Zum Anzeigen klicken',
    
    // Navigation
    nav: {
      dashboard: 'Dashboard',
      users: 'Benutzer & Unternehmen',
      orders: 'Bestellungen',
      invoices: 'Rechnungen',
      stats: 'Statistiken',
    },
    
    // Dashboard
    dashboard: {
      title: 'Admin Dashboard',
      subtitle: 'Plattformübersicht',
      filters: {
        day: 'Heute',
        week: 'Diese Woche',
        month: 'Dieser Monat',
      },
      revenue: 'Umsatz',
      ordersDelivered: 'Bestellungen geliefert',
      ordersPosted: 'Bestellungen veröffentlicht',
      ordersInProgress: 'In Bearbeitung',
      vsLastPeriod: 'vs. letzter Zeitraum',
      vsAverage: 'vs. Durchschnitt',
      revenueChart: 'Umsatzentwicklung',
      ordersChart: 'Bestellungsentwicklung',
    },
    
    // Users & Companies
    users: {
      title: 'Benutzer & Unternehmen',
      subtitle: 'Benutzer- und Unternehmensverwaltung',
      name: 'Name',
      email: 'E-Mail',
      company: 'Unternehmen',
      role: 'Rolle',
      status: 'Status',
      registrationDate: 'Registrierungsdatum',
      actions: 'Aktionen',
      suspend: 'Sperren',
      delete: 'Löschen',
      promoteAdmin: 'Zu Admin befördern',
      viewDetails: 'Details anzeigen',
      filters: {
        role: 'Nach Rolle filtern',
        status: 'Nach Status filtern',
        company: 'Nach Unternehmen filtern',
        date: 'Nach Datum filtern',
        allRoles: 'Alle Rollen',
        allStatuses: 'Alle Status',
        allCompanies: 'Alle Unternehmen',
      },
      statuses: {
        active: 'Aktiv',
        suspended: 'Gesperrt',
        deleted: 'Gelöscht',
      },
      showDeleted: 'Gelöschte Konten anzeigen',
      deletedHiddenCount: '{{count}} gelöschte(s) Konto/Konten ausgeblendet',
      userDetails: {
        title: 'Benutzerdetails',
        personalInfo: 'Persönliche Informationen',
        companyInfo: 'Unternehmensinformationen',
        phone: 'Telefon',
        language: 'Bevorzugte Sprache',
        emailNotifications: 'E-Mail-Benachrichtigungen',
        enabled: 'Aktiviert',
        disabled: 'Deaktiviert',
      },
      companyDetails: {
        createdAt: 'Erstellt am',
        companyCreatedSince: 'Seit dem {{date}}',
        title: 'Unternehmensdetails',
        type: 'Typ',
        siret: 'SIRET',
        address: 'Adresse',
        users: 'Zugehörige Benutzer',
        fleet: 'Flotte',
        drivers: 'Fahrer',
        documents: 'Dokumente',
        vehicleCount: 'Fahrzeuge',
        driverCount: 'Fahrer',
        documentStatus: 'Dokumentstatus',
        valid: 'Gültig',
        expired: 'Abgelaufen',
        missing: 'Fehlend',
      },
      confirmSuspend: 'Sperrung bestätigen',
      confirmSuspendMessage: 'Sind Sie sicher, dass Sie diesen Benutzer sperren möchten?',
      confirmDelete: 'Dieses Konto endgültig löschen',
      confirmDeleteMessage: 'Das Konto wird anonymisiert: personenbezogene Daten werden gelöscht und der Zugang wird dauerhaft gesperrt. Die Auftragshistorie bleibt erhalten. Diese Aktion ist unwiderruflich.',
      deleteSuccess: 'Konto gelöscht und anonymisiert',
      deleteError: 'Fehler beim Löschen des Kontos',
      confirmPromote: 'Beförderung bestätigen',
      confirmPromoteMessage: 'Sind Sie sicher, dass Sie diesen Benutzer zum Administrator befördern möchten?',
      userSuspended: 'Benutzer gesperrt',
      userDeleted: 'Benutzer gelöscht',
      userPromoted: 'Benutzer zum Administrator befördert',
      error: 'Ein Fehler ist aufgetreten',
    },
    
    // Orders
    adminOrders: {
      title: 'Bestellungen',
      subtitle: 'Bestellverwaltung',
      orderId: 'Bestellungs-ID',
      shipper: 'Versender',
      transporter: 'Transporteur',
      amount: 'Betrag',
      status: 'Status',
      date: 'Datum',
      actions: 'Aktionen',
      viewDetails: 'Details anzeigen',
      markDelivered: 'Als geliefert markieren',
      cancelOrder: 'Stornieren',
      viewInvoice: 'Rechnung anzeigen',
      filters: {
        status: 'Nach Status filtern',
        date: 'Nach Datum filtern',
        shipper: 'Nach Versender filtern',
        transporter: 'Nach Transporteur filtern',
        allStatuses: 'Alle Status',
      },
      orderDetails: {
        title: 'Bestelldetails',
        route: 'Route',
        cargo: 'Fracht',
        pricing: 'Preisgestaltung',
        documents: 'Dokumente',
        tracking: 'Verfolgung',
      },
      confirmMarkDelivered: 'Lieferung bestätigen',
      confirmMarkDeliveredMessage: 'Sind Sie sicher, dass Sie diese Bestellung als geliefert markieren möchten?',
      confirmCancel: 'Stornierung bestätigen',
      confirmCancelMessage: 'Sind Sie sicher, dass Sie diese Bestellung stornieren möchten?',
      orderMarkedDelivered: 'Bestellung als geliefert markiert',
      orderCancelled: 'Bestellung storniert',
      error: 'Ein Fehler ist aufgetreten',
    },
    
    // Invoices
    invoices: {
      title: 'Rechnungen',
      subtitle: 'Rechnungsverwaltung',
      invoiceId: 'Rechnungs-ID',
      shipper: 'Versender',
      transporter: 'Transporteur',
      amount: 'Betrag',
      status: 'Status',
      date: 'Datum',
      actions: 'Aktionen',
      markPaidAction: 'Als bezahlt markieren',
      report: 'Melden',
      viewDetails: 'Details anzeigen',
      statuses: {
        pending: 'Ausstehend',
        paid: 'Bezahlt',
        reported: 'Gemeldet',
        cancelled: 'Storniert',
      },
      invoiceDetails: {
        title: 'Rechnungsdetails',
        shipperInfo: 'Versenderinformationen',
        transporterInfo: 'Transporteurinformationen',
        orderInfo: 'Bestellinformationen',
        history: 'Verlauf',
        comments: 'Admin-Kommentare',
        addComment: 'Kommentar hinzufügen',
      },
      confirmMarkPaid: 'Zahlung bestätigen',
      confirmMarkPaidMessage: 'Sind Sie sicher, dass Sie diese Rechnung als bezahlt markieren möchten?',
      confirmReport: 'Rechnung melden',
      confirmReportMessage: 'Sind Sie sicher, dass Sie diese Rechnung melden möchten?',
      confirmCancel: 'Rechnung stornieren',
      confirmCancelMessage: 'Sind Sie sicher, dass Sie diese Rechnung stornieren möchten? Diese Aktion ist irreversibel.',
      reportReason: 'Meldegrund',
      invoiceMarkedPaid: 'Rechnung als bezahlt markiert',
      invoiceReported: 'Rechnung gemeldet',
      commentAdded: 'Kommentar hinzugefügt',
      error: 'Ein Fehler ist aufgetreten',
    },
  },

  // Shipper
  shipper: {
    dashboard: {
      title: 'Versender-Dashboard',
      createOrder: 'Auftrag erstellen',
      pendingReservations: 'Ausstehende Reservierungen',
      pendingReservationsSubtitle:
        '{{count}} Transportunternehmer haben Ihre Aufträge gebucht',
      pendingBids: 'Erhaltene Angebote',
      pendingBidsSubtitle: 'Sie haben {{count}} Angebot(e) zur Validierung',
      ordersInProgress: 'Aufträge in Bearbeitung',
      ordersInProgressSubtitle: 'Ihre zugewiesenen und laufenden Aufträge',
      viewAllOrders: 'Alle meine Aufträge ansehen',
      noOrdersInProgress: 'Noch keine laufenden Aufträge',
    },
    stats: {
      totalOrders: 'Gesamtaufträge',
      inProgress: 'In Bearbeitung',
      delivered: 'Geliefert',
      drafts: 'Entwürfe',
    },
    reservation: {
      pending: 'Reservierung ausstehend',
      transporter: 'Transportunternehmer',
      confirming: 'Bestätigung...',
      confirm: 'Bestätigen',
      declining: 'Ablehnen...',
      decline: 'Ablehnen',
    },
    bids: {
      order: 'Bestellung',
      pickup: 'Abholung',
      delivery: 'Lieferung',
      transporter: 'Transportunternehmen',
      proposedAmount: 'Vorgeschlagener Betrag',
      message: 'Nachricht',
      submittedOn: 'Eingereicht am',
    },
    messages: {
      reservationConfirmed: 'Reservierung erfolgreich bestätigt',
      reservationDeclined: 'Reservierung abgelehnt',
      bidAccepted: 'Angebot erfolgreich angenommen',
      bidDeclined: 'Angebot abgelehnt',
    },
    errors: {
      confirmError: 'Fehler bei der Bestätigung',
      declineError: 'Fehler beim Ablehnen',
      acceptBidError: 'Fehler beim Annehmen des Angebots',
      declineBidError: 'Fehler beim Ablehnen des Angebots',
    },
  },

  // Transporter
  transporter: {
    dashboard: {
      title: 'Transportunternehmer-Dashboard',
      activeMissions: 'Aktive Missionen',
      noActiveMissions: 'Keine aktiven Missionen',
      checkMarketplace: 'Besuchen Sie den Marketplace, um Missionen zu buchen',
      cancelMissionConfirm:
        'Möchten Sie die Mission {{orderNumber}} wirklich stornieren?',
    },
    stats: {
      availableVehicles: 'Verfügbare Fahrzeuge',
      activeMissions: 'Laufende Missionen',
      availableDrivers: 'Verfügbare Fahrer',
      completedMissions: 'Abgeschlossene Missionen',
    },
    mission: {
      pendingConfirmation: 'Ausstehend',
      assigned: 'Zugewiesen',
      accepted: 'Akzeptiert',
      pickup: 'Abholung',
      delivery: 'Lieferung',
      driver: 'Fahrer:',
      vehicle: 'Fahrzeug:',
    },
    messages: {
      missionCanceled: 'Mission erfolgreich storniert',
    },
  },

  // Landing
  landing: {
    hero: {
      title: 'Velox',
      titleHighlight: 'verwalten Sie Ihre Transportaufträge,',
      titleEnd: 'mühelos',
      subtitle:
        'Eine Progressive Web App, optimiert für Desktop und Mobilgeräte: veröffentlichen Sie Fracht, greifen Sie auf den Marktplatz zu, weisen Sie Fahrer zu, validieren Sie per QR-Code und verwalten Sie Zahlungen — alles an einem Ort.',
      tryFree: 'Kostenlos testen',
      learnMore: 'Mehr erfahren',
      cta: 'Anmelden',
    },
    allYouNeed: {
      title: 'Alles, was Sie brauchen',
      subtitle:
        'Eine umfassende Plattform zur effizienten Verwaltung Ihrer Transport­aktivitäten',
    },
    features: {
      title: 'Hauptfunktionen',
      shipments: {
        title: 'Versandverwaltung',
        description: 'Erstellen, verfolgen und verwalten Sie Ihre Transportaufträge in Echtzeit mit einer intuitiven Oberfläche.',
      },
      fleet: {
        title: 'Flottenverwaltung',
        description: 'Optimieren Sie den Einsatz Ihrer Fahrzeuge und Fahrer mit fortschrittlichen Planungstools.',
      },
      tracking: {
        title: 'Echtzeit-Tracking',
        description: 'Orten Sie Ihre Lieferungen live und halten Sie Ihre Kunden bei jedem Schritt auf dem Laufenden.',
      },
      multiUser: {
        title: 'Mehrbenutzer',
        description: 'Arbeiten Sie effektiv mit Ihrem Team zusammen dank angepasster Rollen und Berechtigungen.',
      },
      planning: {
        title: 'Intelligente Planung',
        description: 'Optimieren Sie Ihre Routen und planen Sie Ihre Missionen mit intelligenten Algorithmen.',
      },
      security: {
        title: 'Maximale Sicherheit',
        description: 'Ihre Daten sind mit den höchsten Sicherheitsstandards geschützt.',
      },
    },
    workflow: {
      title: 'Haupt-Workflow',
      subtitle: 'V1 - vollständiger Marketplace und Prozessablauf',
      steps: {
        step1: {
          badge: 'Schritt 1',
          title: 'Frachtveröffentlichung (Versender)',
          description: 'Erstellung des Unternehmenskontos, Auftragseinrichtung (Anhängertyp, Ziel, Lieferfenster, vorgeschlagener Preis). Die Bestellung erscheint auf dem Marketplace.',
        },
        step2: {
          badge: 'Schritt 2',
          title: 'Auswahl und Buchung (Spediteur)',
          description: 'Registrierung des Spediteurs und Fahrer-Onboarding. Marketplace mit Filtern (Route, Frachttyp, Entfernung). Fracht buchen und bestätigen.',
        },
        step3: {
          badge: 'Schritt 3',
          title: 'Fahrerzuweisung',
          description: 'Automatischer Link zur Erstellung des Fahrerkontos, das mit dem Unternehmen verbunden ist. Der Fahrer nimmt die Mission über die PWA an.',
        },
        step4: {
          badge: 'Schritt 4',
          title: 'Beladung und Abfahrt',
          description: 'Fahrer checkt am Ladeort ein. Validierung über QR-Code oder manuelle Bestätigung → Status wechselt zu "in Transit".',
        },
        step5: {
          badge: 'Schritt 5',
          title: 'Lieferung',
          description: 'Validierung über QR-Code oder "Geliefert"-Button. Hochladen von Fotos und POD/CMR-Dokumenten. Benachrichtigungen werden sofort gesendet, Status im Dashboard aktualisiert.',
        },
        step6: {
          badge: 'Schritt 6',
          title: 'Zahlung und Abschluss',
          description: 'Admin validiert gelieferte Bestellungen für tägliche Zahlungen. Rechnung wird automatisch erstellt. Versender erhält Rechnung und bewertet Spediteur.',
        },
      },
    },
    comparison: {
      title: "Finden Sie die Lösung, die zu Ihnen passt",
      subtitle: "Ob Versender oder Spediteur, Velox vereinfacht die Verwaltung Ihrer Transportvorgänge",
      shipper: {
        title: "Versender",
        benefits: [
          "Veröffentlichen Sie Ihre Frachtaufträge mit wenigen Klicks",
          "Zugang zu einem Netzwerk verifizierter Spediteure",
          "Verfolgen Sie Ihre Lieferungen in Echtzeit",
          "Verwalten Sie Ihre Rechnungen und Zahlungen einfach",
          "Profitieren Sie von einem dedizierten Kundenservice"
        ],
        cta: "Als Versender starten"
      },
      transporter: {
        title: "Spediteure",
        benefits: [
          "Zugang zu Tausenden von Frachtangeboten",
          "Optimieren Sie Ihre Flottenauslastung",
          "Verwalten Sie Ihre Fahrer und Fahrzeuge einfach",
          "Erhalten Sie Ihre Zahlungen schnell",
          "Wachsen Sie Ihr Geschäft effizient"
        ],
        cta: "Als Spediteur starten"
      }
    },
    faq: {
      title: 'Häufig Gestellte Fragen',
      subtitle: 'Alles, was Sie über Velox wissen müssen',
      questions: {
        whatIsVelox: {
          question: 'Was ist Velox?',
          answer: 'Velox ist eine Progressive Web App, die das Management von Transportmissionen zwischen Versendern, Spediteuren und Fahrern vereinfacht. Sie zentralisiert die Veröffentlichung von Fracht, Buchung, Zuweisung, Liefervalidierung und Zahlungsverfolgung.',
        },
        needDownload: {
          question: 'Muss ich eine App herunterladen?',
          answer: 'Nein. Velox ist eine PWA — sie funktioniert direkt auf Desktop- und Mobilbrowsern. Keine Installation aus dem App Store oder Google Play erforderlich.',
        },
        whoCanUse: {
          question: 'Wer kann Velox nutzen?',
          answer: 'Velox unterstützt drei Hauptbenutzertypen: Versender (Frachtaufträge veröffentlichen und Lieferungen verfolgen), Spediteure (Fracht durchsuchen und buchen, Missionen an Fahrer zuweisen) und Fahrer (Missionen empfangen, Schritte validieren, Lieferdokumente hochladen).',
        },
        driverJoin: {
          question: 'Wie treten Fahrer der Plattform bei?',
          answer: 'Fahrer erhalten einen automatischen Link von ihrem Spediteur. Sie erstellen in wenigen Schritten ein verbundenes Fahrerkonto.',
        },
        deliveryValidation: {
          question: 'Wie wird die Lieferung validiert?',
          answer: 'Die Lieferung kann durch Scannen eines QR-Codes oder über eine manuelle Bestätigungsschaltfläche validiert werden. Fahrer können auch POD/CMR-Dokumente und Fotos direkt hochladen.',
        },
        notifications: {
          question: 'Welche Art von Benachrichtigungen werden gesendet?',
          answer: 'Velox sendet E-Mail-Benachrichtigungen an Versender, Spediteure und Fahrer für wichtige Ereignisse: Buchungen, Missionszuweisungen, Statusaktualisierungen und Lieferbestätigungen.',
        },
        multilingual: {
          question: 'Ist Velox mehrsprachig und multi-währungs?',
          answer: 'Ja. Die PWA unterstützt mehrere Sprachen und Währungen, um sich an verschiedene Märkte anzupassen.',
        },
        payment: {
          question: 'Wie funktioniert die Zahlung?',
          answer: 'Sobald eine Lieferung als abgeschlossen markiert ist, validiert der Velox-Administrator sie für die tägliche Auszahlung. Eine Rechnung wird automatisch generiert und an den Versender gesendet.',
        },
        history: {
          question: 'Kann ich meine vergangenen Missionen oder Sendungen sehen?',
          answer: 'Absolut. Velox enthält eine vollständige Historie für jede Rolle: Versender (Lieferungen, Kosten, KPIs), Spediteur (Sendungen, Bewertungen, Präferenzen) und Fahrer (Missionen + alle zugehörigen Dokumente).',
        },
        production: {
          question: 'Ist Velox eine Produktionsanwendung?',
          answer: 'Diese Version ist ein Prototyp (V1), der sich auf den Kernworkflow und Marketplace-Funktionen konzentriert. Weitere Funktionen werden in den nächsten Iterationen hinzugefügt.',
        },
      },
    },
    ctaSection: {
      title: 'Bereit, Ihre Logistik zu verändern?',
      subtitle:
        'Schließen Sie sich den Unternehmen an, die ihren Transport mit Velox optimieren',
      createAccount: 'Kostenloses Konto erstellen',
    },
    cta: {
      title: 'Bereit loszulegen?',
      subtitle: 'Jetzt mitmachen',
    },
    footer: {
      copyright: '© 2025 Velox. Alle Rechte vorbehalten.',
    },
  },

  // Not Found
  notFound: {
    message: 'Ups! Seite nicht gefunden',
    backToHome: 'Zurück zur Startseite',
  },

  // Create Order
  createOrder: {
    title: 'Bestellung erstellen',
    subtitle: 'Geben Sie Ihre Transportinformationen ein',
    
    section1: {
      title: '1. Route',
      description: 'Abhol- und Lieferinformationen',
      pickup: 'Abholung',
      delivery: 'Lieferung',
    },
    
    address: {
      streetNumber: 'Nummer',
      streetName: 'Straßenname',
      postalCode: 'Postleitzahl',
      city: 'Stadt',
      country: 'Land',
      streetNumberPlaceholder: '123',
      streetNamePlaceholder: 'Republikstraße',
      postalCodePlaceholder: '75000',
      cityPlaceholder: 'Paris',
      countryPlaceholder: 'Frankreich',
    },
    
    dateTime: {
      pickupDate: 'Abholdatum',
      pickupTime: 'Abholzeit',
      deliveryDate: 'Lieferdatum',
      deliveryTime: 'Lieferzeit',
      chooseDate: 'Datum wählen',
    },
    
    contact: {
      label: 'Kontakt',
      phone: 'Telefon',
      contactPlaceholder: 'Max Mustermann',
      phonePlaceholder: '6 12 34 56 78',
    },
    
    access: {
      detailsLabel: 'Zugangsdetails (optional)',
      detailsPlaceholder: 'Z.B.: Torcode 1234, Eingang über hinteren Parkplatz, Büro 3 klingeln...',
      detailsHelper: 'Geben Sie Details zum Zugang zum Abholort an',
      deliveryDetailsPlaceholder: 'Z.B.: Türklingel 2. Stock, Lieferung straßenseitig, Besucherparkplatz...',
      deliveryDetailsHelper: 'Geben Sie Details zum Zugang zum Lieferort an',
      photosLabel: 'Zugangsfotos (optional)',
      photosHelper: 'Maximal 5 Bilder, um den Abholort zu finden',
      deliveryPhotosHelper: 'Maximal 5 Bilder, um den Lieferort zu finden',
      maxImagesError: 'Maximal 5 Bilder erlaubt',
    },
    
    gps: {
      calculating: 'GPS-Position wird berechnet...',
      calculated: 'GPS-Position berechnet',
    },
    
    section2: {
      title: '2. Fracht',
      subtitle: 'Details der zu transportierenden Fracht',
      cargoTitle: 'Frachttitel',
      cargoTitlePlaceholder: 'Z.B.: Paletten mit Elektronik, Büromöbel...',
      vehicleType: 'Fahrzeugtyp',
      vehicleTypePlaceholder: 'Typ auswählen',
      anyVehicle: 'Beliebiger Fahrzeugtyp',
      weight: 'Gewicht (kg)',
      weightPlaceholder: '1000',
      volume: 'Volumen (m³)',
      volumePlaceholder: '10.5',
      unitType: 'Einheitstyp',
      unitTypePlaceholder: 'Typ auswählen',
      quantity: 'Menge',
      quantityPlaceholder: 'Z.B.: 12',
      cargoDescription: 'Frachtbeschreibung',
      cargoDescriptionPlaceholder: 'Beschreiben Sie die Art Ihrer Fracht...',
      specialInstructions: 'Besondere Anweisungen',
      specialInstructionsPlaceholder: 'Spezifische Anforderungen, Zeitbeschränkungen...',
      cargoPhoto: 'Frachtfoto (optional)',
      cargoPhotoHelper: 'Ein Bild zur Darstellung Ihrer Fracht',
    },
    
    unitTypes: {
      palettes: 'Paletten',
      caisses: 'Kisten',
      euroPalettes: 'Euro-Paletten',
    },
    
    section3: {
      title: '3. Preisgestaltung',
      subtitle: 'Methode zur Preisfestlegung',
      pricingMode: 'Preismodus',
      fixedPrice: 'Festpreis',
      fixedPriceDesc: 'Sie legen den Transportpreis fest',
      auction: 'Auktion',
      auctionDesc: 'Transportunternehmen geben ihre Tarife ab',
      proposedPrice: 'Vorgeschlagener Preis (€)',
      proposedPricePlaceholder: '850.00',
    },
    
    section4: {
      title: '4. Sichtbarkeit',
      subtitle: 'Bestellungsveröffentlichung',
      marketplaceVisible: 'Auf Marktplatz sichtbar machen',
      marketplaceVisibleDesc: 'Transportunternehmen können sehen und Angebote abgeben',
    },
    
    actions: {
      saveDraft: 'Entwurf speichern',
      createOrder: 'Bestellung erstellen',
      creating: 'Wird erstellt...',
    },
    
    toasts: {
      draftSaved: 'Entwurf gespeichert!',
      orderCreated: 'Bestellung erstellt und veröffentlicht!',
      priceRequired: 'Vorgeschlagener Preis erforderlich, um Bestellung zu veröffentlichen',
      error: 'Fehler beim Erstellen der Bestellung',
    },
    
    validation: {
      numberTooLong: 'Nummer zu lang',
      streetNameRequired: 'Straßenname erforderlich (mind. 3 Zeichen)',
      streetNameTooLong: 'Straßenname zu lang',
      postalCodeRequired: 'Postleitzahl erforderlich',
      postalCodeTooLong: 'Postleitzahl zu lang',
      cityRequired: 'Stadt erforderlich',
      cityTooLong: 'Stadt zu lang',
      countryRequired: 'Land erforderlich',
      countryTooLong: 'Land zu lang',
      pickupDateRequired: 'Abholdatum erforderlich',
      deliveryDateRequired: 'Lieferdatum erforderlich',
      invalidTime: 'Ungültige Zeit (Format HH:MM)',
      contactRequired: 'Kontaktname erforderlich',
      contactTooLong: 'Name zu lang',
      phoneRequired: 'Telefon erforderlich (mind. 8 Ziffern)',
      phoneTooLong: 'Telefon zu lang',
      detailsTooLong: 'Details zu lang',
      cargoTitleRequired: 'Titel erforderlich (mind. 3 Zeichen)',
      cargoTitleTooLong: 'Titel zu lang',
      vehicleTypeRequired: 'Fahrzeugtyp erforderlich',
      weightRequired: 'Gewicht erforderlich',
      weightMax: 'Maximalgewicht 100.000 kg',
      volumeMax: 'Maximalvolumen 200 m³',
      quantityNegative: 'Menge kann nicht negativ sein',
      quantityMax: 'Maximum 100',
      descriptionRequired: 'Beschreibung erforderlich (mind. 10 Zeichen)',
      descriptionTooLong: 'Beschreibung zu lang',
      instructionsTooLong: 'Anweisungen zu lang',
      priceRequired: 'Preis erforderlich',
      priceMax: 'Maximalpreis 1.000.000€',
    },
  },

  // Rating System
  rating: {
    title: 'Lieferung bewerten',
    question: 'Wie war diese Lieferung?',
    comment: 'Kommentar (optional)',
    commentPlaceholder: 'Teilen Sie Ihre Erfahrung mit diesem Partner...',
    submit: 'Bewertung absenden',
    submitting: 'Wird gesendet...',
    success: 'Vielen Dank für Ihre Bewertung!',
    error: 'Fehler beim Absenden der Bewertung',
    alreadyRated: 'Sie haben diese Bestellung bereits bewertet',
    rateDelivery: 'Lieferung bewerten',
    rateClient: 'Diesen Kunden bewerten',
    toRate: 'Zu bewerten',
    noRatingsYet: 'Noch keine Bewertungen',
    
    excellent: 'Ausgezeichnet! 🌟',
    veryGood: 'Sehr gut 👍',
    good: 'Gut ✓',
    fair: 'Ausreichend',
    poor: 'Mangelhaft',
    
    companyProfile: {
      title: 'Bewertungen',
      average: 'Durchschnittsbewertung',
      totalReviews: 'Bewertungen',
      distribution: 'Bewertungsverteilung',
    },
    
    yourRating: 'Ihre Bewertung',
    partnerRating: 'Partnerbewertung',
  },

  // Toast
  toast: {
    reservationConfirmed: 'Reservierung erfolgreich bestätigt',
    reservationDeclined: 'Reservierung abgelehnt',
    error: 'Ein Fehler ist aufgetreten',
  },

  // Legal
  legal: {
    termsOfService: {
      title: "Allgemeine Geschäftsbedingungen",
      lastUpdate: "Letzte Aktualisierung",
      section1: {
        title: "1. Zweck",
        content: "Diese Allgemeinen Geschäftsbedingungen (AGB) definieren die Nutzungsbedingungen der Velox-Plattform, einem Dienst zur Verbindung von Versendern und Transportunternehmern. Durch die Nutzung unserer Plattform akzeptieren Sie diese AGB vorbehaltlos.",
      },
      section2: {
        title: "2. Registrierung und Benutzerkonto",
        content: "Die Nutzung der Plattform erfordert die Erstellung eines Benutzerkontos. Sie verpflichten sich, genaue und aktuelle Informationen bereitzustellen, einschließlich Ihrer Steuer-ID/USt-IdNr und Bankdaten (IBAN). Sie sind für die Vertraulichkeit Ihrer Anmeldedaten verantwortlich.",
      },
      section3: {
        title: "3. Angebotene Dienstleistungen",
        content: "Velox verbindet Versender, die Transportdienstleistungen benötigen, mit professionellen Transportunternehmern. Die Plattform erleichtert die Auftragserstellung, Angebotseinreichung, Echtzeit-Tracking und Rechnungsverwaltung. Velox fungiert ausschließlich als Vermittler und ist nicht Vertragspartei des Transportvertrags.",
      },
      section4: {
        title: "4. Benutzerpflichten",
        content: "Versender verpflichten sich, genaue Informationen über ihre Waren bereitzustellen. Transportunternehmer verpflichten sich, über die erforderlichen Lizenzen und Versicherungen zu verfügen. Alle Benutzer verpflichten sich, die geltende Gesetzgebung einzuhalten und die Plattform nicht für betrügerische Zwecke zu nutzen.",
      },
      section5: {
        title: "5. Preisgestaltung und Zahlung",
        content: "Die Preise werden frei zwischen Versendern und Transportunternehmern ausgehandelt. Velox erhebt eine Provision für jede über die Plattform durchgeführte Transaktion. Zahlungen sind sicher und werden über unser integriertes Zahlungssystem abgewickelt. Rechnungen sind im Abrechnungsbereich verfügbar.",
      },
      section6: {
        title: "6. Verantwortlichkeiten",
        content: "Velox kann nicht für Schäden haftbar gemacht werden, die aus der Durchführung des Transportvertrags zwischen Versender und Transportunternehmer resultieren. Die Haftung von Velox beschränkt sich auf die Bereitstellung der Plattform. Im Streitfall verpflichten sich die Parteien, eine gütliche Lösung zu suchen, bevor rechtliche Schritte eingeleitet werden.",
      },
    },
    privacyPolicy: {
      title: "Datenschutzerklärung",
      lastUpdate: "Letzte Aktualisierung",
      section1: {
        title: "1. Herausgeber der Plattform",
        content: "Velox wird herausgegeben von [Firmenname], einer vereinfachten Aktiengesellschaft mit einem Kapital von [Betrag] Euro, eingetragen im Handelsregister von [Stadt] unter der Nummer [Nummer], mit Sitz in [vollständige Adresse]. Verantwortlicher Direktor: [Name]. Kontakt: contact@velox.com",
      },
      section2: {
        title: "2. Hosting",
        content: "Die Velox-Plattform wird von Supabase Inc., 970 Toa Payoh North, #07-04, Singapore 318992, gehostet. Der Dienst nutzt eine sichere Cloud-Infrastruktur mit Servern in Europa (DSGVO-konform).",
      },
      section3: {
        title: "3. Schutz personenbezogener Daten",
        content: "Gemäß DSGVO haben Sie das Recht auf Zugang, Berichtigung und Löschung Ihrer personenbezogenen Daten. Die erfassten Daten (Name, E-Mail, Telefon, Steuer-ID, IBAN) sind für den Betrieb des Dienstes erforderlich und werden sicher gespeichert. Sie werden niemals ohne Ihre Zustimmung an Dritte weitergegeben.",
      },
      section4: {
        title: "4. Cookies",
        content: "Die Plattform verwendet technische Cookies, die für den Betrieb des Dienstes unerlässlich sind (Authentifizierung, Spracheinstellungen). Es werden keine Werbe- oder Tracking-Cookies verwendet. Sie können Ihren Browser so konfigurieren, dass er Cookies ablehnt, dies kann jedoch einige Funktionen beeinträchtigen.",
      },
      section5: {
        title: "5. Geistiges Eigentum",
        content: "Alle Elemente der Velox-Plattform (Logos, Texte, Grafiken, Software) sind urheberrechtlich geschützt und ausschließliches Eigentum von Velox. Jede unbefugte Vervielfältigung, Darstellung oder Ausbeutung ist verboten.",
      },
      section6: {
        title: "6. Anwendbares Recht",
        content: "Diese Rechtshinweise unterliegen französischem Recht. Im Streitfall sind ausschließlich französische Gerichte zuständig. Bei Fragen zu den Rechtshinweisen können Sie uns kontaktieren unter: legal@velox.com",
      },
    },
  },
  support: {
    title: 'Velox Support',
    description: 'Kontaktieren Sie unser Support-Team',
    callVelox: 'Velox anrufen',
    email: 'E-Mail',
    phone: 'Telefon',
    adminTitle: 'Velox-Support-Kontakte',
    adminDescription: 'Diese Angaben werden Nutzern beim Kontakt mit dem Support angezeigt.',
  },
  supportChat: {
    title: 'Velox Support',
    adminTitle: 'Support-Tickets',
    adminNav: 'Support',
    open: 'Chat öffnen',
    yourTickets: 'Ihre Tickets',
    newTicket: 'Neues Ticket',
    empty: 'Noch keine Tickets',
    writeMessage: 'Nachricht schreiben…',
    send: 'Senden',
    skip: 'Diesen Schritt überspringen',
    pickOrder: 'Wählen Sie die zugehörige Bestellung:',
    descPlaceholder: 'Beschreiben Sie Ihr Anliegen…',
    selectTicket: 'Wählen Sie ein Ticket, um die Konversation anzuzeigen',
    markResolved: 'Als gelöst markieren',
    close: 'Schließen',
    assignMe: 'Mir zuweisen',
    filter: { all: 'Alle Status' },
    status: {
      bot: 'Qualifizierung',
      pending_admin: 'Wartend',
      open: 'Offen',
      resolved: 'Gelöst',
      closed: 'Geschlossen',
    },
    cat: {
      offer: 'Ein Angebot',
      mission: 'Eine Mission',
      account: 'Mein Konto',
      payment: 'Zahlung / Abrechnung',
      other: 'Sonstiges',
    },
    bot: {
      greeting: 'Hallo 👋 Ich bin der Velox-Assistent. Ich leite Sie an die richtige Person weiter.',
      askCategory: 'Worum geht es bei Ihrer Anfrage?',
      askContext: 'Auf welche Bestellung bezieht sich Ihre Anfrage? (Sie können diesen Schritt auch überspringen)',
      askDescription: 'Beschreiben Sie Ihre Anfrage kurz, unser Team meldet sich umgehend.',
      handoff: 'Danke! Ein Mitglied des Velox-Teams übernimmt und antwortet so schnell wie möglich.',
    },
  },
  adminCreate: {
    navShort: 'Konto erstellen',
    title: 'Konto erstellen',
    subtitle: 'Erstellen Sie ein Verlader- oder Transportunternehmen oder fügen Sie einen Fahrer einem bestehenden Unternehmen hinzu.',
    tabs: {
      shipper: 'Verladerunternehmen',
      transporter: 'Transportunternehmen',
      driver: 'Fahrer',
      admin: 'Administrator',
    },
    sections: {
      company: 'Unternehmensinformationen',
      ownerInfo: 'Kontoinhaber',
      driverInfo: 'Fahrerinformationen',
      adminInfo: 'Administrator-Informationen',
      attachToTransporter: 'Transportunternehmen',
      activation: 'Kontoaktivierung',
    },
    fields: {
      foundedDate: 'Gründungsdatum',
      companyName: 'Firmenname',
      companyPhone: 'Firmentelefon',
      transporter: 'Transportunternehmen',
      transporterPlaceholder: 'Unternehmen auswählen',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      phone: 'Telefon',
      password: 'Temporäres Passwort',
      passwordPlaceholder: 'Mindestens 8 Zeichen',
      passwordHint: 'Der Nutzer kann es nach der Anmeldung ändern.',
    },
    mode: {
      invite: {
        label: 'Einladung per E-Mail senden',
        desc: 'Der Nutzer erhält einen Link, um sein Passwort festzulegen und das Konto zu aktivieren.',
      },
      direct: {
        label: 'Direkt mit Passwort erstellen',
        desc: 'Das Konto ist sofort aktiv. Teilen Sie das Passwort mit der Person.',
      },
    },
    submit: {
      invite: 'Einladung senden',
      direct: 'Konto erstellen',
    },
    success: {
      invite: 'Einladung erfolgreich gesendet.',
      direct: 'Konto erfolgreich erstellt.',
    },
    errors: {
      missingUser: 'Alle Nutzerfelder ausfüllen.',
      missingCompany: 'Firmenname und Telefon ausfüllen.',
      pickCompany: 'Transportunternehmen auswählen.',
      shortPassword: 'Passwort muss mindestens 8 Zeichen lang sein.',
      emailTaken: 'Diese E-Mail-Adresse gehört bereits zu einem bestehenden Konto. Es wurde kein Konto erstellt und keine E-Mail gesendet.',
      generic: 'Fehler beim Erstellen des Kontos.',
    },
  },
  emailTemplates: {
    tab: 'E-Mails',
    title: 'E-Mail-Vorlagen',
    description: 'Passen Sie die E-Mails an, die beim Anlegen von Konten gesendet werden.',
    invitation: 'Einladung (Aktivierung durch Nutzer)',
    passwordReset: 'Passwort zurücksetzen',
    signupWelcome: "Willkommen (Registrierung)",
    emailChange: "E-Mail-Adressänderung",
    directWelcome: 'Willkommen (direkte Erstellung)',
    subject: 'Betreff',
    bodyHtml: 'HTML-Inhalt',
    enabled: 'E-Mail aktiviert',
    enabledHint: 'Wenn deaktiviert, wird keine E-Mail gesendet.',
    bccAdmin: 'Blindkopie (BCC) an Admin',
    bccAdminHint: 'Eine versteckte Kopie jeder E-Mail erhalten.',
    variables: 'Verfügbare Variablen',
  },
  adminDocuments: {
    docSearchPlaceholder: 'Dokument suchen (Datei, Kategorie, Auftrag, Kennzeichen, Fahrer)...',
    categoryAll: 'Alle Kategorien',
    statusAll: 'Alle Status',
    resetFilters: 'Zurücksetzen',
    noResults: 'Kein Dokument entspricht Ihrer Suche.',
    companiesShown_one: '{{count}} Unternehmen angezeigt',
    companiesShown_other: '{{count}} Unternehmen angezeigt',
    addedByVelox: 'Von Velox hinzugefügt',
    categories: {
      kyc: 'KYC / Identität',
      insurance_license: 'Versicherung & Lizenz',
      contract: 'Vertrag / kaufmännisch',
      registration_card: 'Fahrzeugschein',
      inspection: 'Technische Prüfung',
      driver_license: 'Führerschein',
      loading_photos: 'Ladefotos',
      delivery_photos: 'Lieferfotos',
      cmr: 'CMR / Lieferschein',
      other: 'Sonstiges',
    },
    add: {
      button: 'Dokument hinzufügen',
      buttonShort: 'Hinzufügen',
      title: 'Dokument hinzufügen',
      description: 'Dieses Dokument wird {{company}} zugeordnet und ist für dieses Unternehmen sichtbar.',
      scope: 'Zuordnen zu',
      scopeCompany: 'Unternehmen (Onboarding)',
      scopeOrder: 'Einem Auftrag (Fracht)',
        scopeVehicle: 'Ein Fahrzeug',
        scopeDriver: 'Ein Fahrer',
        vehicle: 'Fahrzeug',
        vehicleSearch: 'Fahrzeug suchen...',
        vehiclePlaceholder: 'Fahrzeug auswählen',
        noVehicles: 'Dieses Unternehmen hat noch kein Fahrzeug registriert.',
        noDrivers: 'Dieses Unternehmen hat noch keinen Fahrer registriert.',
        vehicleRequired: 'Bitte wählen Sie ein Fahrzeug aus.',
        driver: 'Fahrer',
        driverSearch: 'Fahrer suchen...',
        driverPlaceholder: 'Fahrer auswählen',
        driverRequired: 'Bitte wählen Sie einen Fahrer aus.',
      order: 'Auftrag',
      orderSearch: 'Auftrag suchen...',
      orderPlaceholder: 'Auftrag auswählen',
      category: 'Kategorie',
      label: 'Bezeichnung',
      labelPlaceholder: 'z. B. Versicherungsnachweis 2026',
      expiry: 'Ablaufdatum (optional)',
      notes: 'Interne Notiz (optional)',
      chooseFile: 'Datei auswählen',
      fileHint: 'Zulässige Formate: PDF, JPG, PNG (max. 10 MB)',
      uploading: 'Wird hochgeladen...',
      submit: 'Dokument hinzufügen',
      success: 'Dokument hinzugefügt',
      error: 'Das Dokument konnte nicht hinzugefügt werden',
      invalidType: 'Nicht unterstütztes Format. Verwenden Sie PDF, JPG oder PNG.',
      tooLarge: 'Datei zu groß (max. 10 MB)',
      fileRequired: 'Bitte wählen Sie eine Datei aus',
      orderRequired: 'Bitte wählen Sie einen Auftrag aus',
      deleteTitle: 'Dieses Dokument löschen?',
      deleteDescription: '{{name}} wird endgültig gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
      deleteSuccess: 'Dokument gelöscht',
      deleteError: 'Das Dokument konnte nicht gelöscht werden',
    },
    breadcrumb: 'Dokumente',
    shippers: 'Versender',
    transporters: 'Transporteure',
    title: 'Benutzerdokumente',
    subtitle: 'Wählen Sie ein Unternehmen, um seine Dokumente kategorisiert anzuzeigen.',
    searchPlaceholder: 'Unternehmen suchen...',
    noCompanies: 'Kein {{side}}-Unternehmen.',
    sideShipper: 'Versender',
    sideTransporter: 'Transporteur',
    usersCount_one: '{{count}} Benutzer',
    usersCount_other: '{{count}} Benutzer',
    docsCount_one: '{{count}} Dokument',
    docsCount_other: '{{count}} Dokumente',
    expiredCount_one: '{{count}} abgelaufen',
    expiredCount_other: '{{count}} abgelaufen',
    missingCount_one: '{{count}} fehlend',
    missingCount_other: '{{count}} fehlend',
    complete: 'Vollständig',
    back: 'Zurück',
    sectionOnboarding: 'Onboarding',
    sectionFleet: 'Flotte',
    sectionFreight: 'Fracht',
    onboardingTitle: 'Onboarding-Dokumente',
    onboardingDesc: 'Handelsregister, USt, IBAN, Transportlizenz, Haftpflicht, AGB…',
    onboardingEmpty: 'Keine Onboarding-Dokumente für dieses Unternehmen hochgeladen.',
    fleetTitle: 'Flottendokumente',
    trucks: 'LKW',
    trailers: 'Anhänger',
    drivers: 'Fahrer',
    emptyTrucks: 'Keine LKW registriert.',
    emptyTrailers: 'Keine Anhänger registriert.',
    emptyDrivers: 'Keine Fahrer registriert.',
    noDocsResource: 'Keine zugehörigen Dokumente.',
    freightTitle: 'Frachtdokumente',
    freightDesc: 'Ein Eintrag pro Auftrag: Transportauftrag, CMR / POD, Zoll, Reklamationen, Fotos.',
    freightEmpty: 'Kein Auftrag mit Dokumenten.',
    orderLabel: 'Auftrag {{number}}',
    noDocs: 'Keine Dokumente.',
    tableNature: 'Typ',
    tableFile: 'Datei',
    tableStatus: 'Status',
    tableSize: 'Größe',
    tableDate: 'Datum',
    tableAction: 'Aktion',
    statusVerified: 'Verifiziert',
    statusExpiring: 'Läuft bald ab',
    statusExpired: 'Abgelaufen',
    statusUnverified: 'Nicht verifiziert',
    licensePrefix: 'Führerschein',
    licenseExpires: 'läuft ab',
    licenseNotSet: 'Führerschein nicht erfasst',
    openError: 'Dokument kann nicht geöffnet werden',
    natureRegistration: 'Fahrzeugschein',
    natureInsurance: 'Versicherung',
    natureInspection: 'TÜV',
    natureOther: 'Sonstiges',
    natureCargo: 'Frachtfoto',
    natureStart: 'Abholfoto',
    natureDelivery: 'Lieferfoto',
    natureDocument: 'Dokument',
  },
  footer: {
    tagline: 'Die Transport- und Frachtplattform, die Versender, Transportunternehmen und Fahrer in ganz Europa verbindet.',
    legalTitle: 'Rechtliche Informationen',
    contactTitle: 'Support',
    partnersTitle: 'Unsere Partner',
    copyright: '© 2026 Velox. Alle Rechte vorbehalten.',
    links: {
      about: 'Über uns',
      terms: 'Allgemeine Geschäftsbedingungen',
      privacy: 'Datenschutzerklärung',
      legalNotice: 'Impressum',
      cookiePolicy: 'Cookie-Richtlinie',
      cookieSettings: 'Cookie-Einstellungen',
    },
    short: {
      about: 'Über uns',
      terms: 'AGB',
      privacy: 'Datenschutz',
      legalNotice: 'Impressum',
      cookies: 'Cookies',
      support: 'Support',
    },
  },
  legalNotice: {
    back: 'Zurück zur Startseite',
    title: 'Impressum',
    lastUpdated: 'Zuletzt aktualisiert: Januar 2026',
    sections: {
      publisher: {
        title: 'Herausgeber',
        body: 'Velox\nPlattform für Transport- und Frachtmanagement.\nKontakt: support@myvelox.eu\nWebsite: https://myvelox.eu',
      },
      hosting: {
        title: 'Hosting',
        body: 'Die Website und ihre Dienste werden von Cloud-Infrastrukturanbietern mit Sitz in der Europäischen Union gehostet.',
      },
      intellectualProperty: {
        title: 'Geistiges Eigentum',
        body: 'Sämtliche Inhalte der Plattform (Texte, Bilder, Logos, Code) sind urheberrechtlich geschützt. Jede Vervielfältigung oder Weiterverwendung ohne vorherige schriftliche Genehmigung ist untersagt.',
      },
      dataProtection: {
        title: 'Datenschutz',
        body: 'Personenbezogene Daten werden gemäß DSGVO verarbeitet. Weitere Informationen finden Sie in unserer Datenschutzerklärung. Ihre Rechte auf Auskunft, Berichtigung und Löschung können Sie über unseren Support ausüben.',
      },
      contact: {
        title: 'Kontakt',
        body: 'Bei Fragen zu diesem Impressum wenden Sie sich bitte über die App oder per E-Mail an unser Support-Team.',
      },
    },
  },
  cookies: {
    alwaysOn: 'Immer aktiv',
    banner: {
      title: 'Wir respektieren Ihre Privatsphäre',
      description: 'Wir verwenden unbedingt erforderliche Cookies für den Betrieb von Velox und, mit Ihrer Einwilligung, Funktions- und Analyse-Cookies.',
      readPolicy: 'Cookie-Richtlinie lesen',
      customize: 'Anpassen',
      acceptAll: 'Alle akzeptieren',
      rejectAll: 'Alle ablehnen',
      save: 'Auswahl speichern',
    },
    categories: {
      necessary: {
        title: 'Unbedingt erforderliche Cookies',
        description: 'Für den Betrieb der Website unerlässlich (Sitzung, Sicherheit, Speicherung Ihrer Cookie-Auswahl).',
      },
      functional: {
        title: 'Funktions-Cookies',
        description: 'Speichern Ihre Präferenzen, z. B. die gewählte Sprache.',
      },
      analytics: {
        title: 'Analyse-Cookies',
        description: 'Helfen uns zu verstehen, wie die Website genutzt wird (PostHog), um sie zu verbessern.',
      },
    },
  },
  invite: {
    title: 'Velox beitreten',
    subtitle: 'Sie wurden eingeladen beizutreten:',
    subtitleRole: 'als',
    email: 'E-Mail',
    firstName: 'Vorname',
    lastName: 'Nachname',
    password: 'Passwort',
    passwordPlaceholder: 'Mindestens 8 Zeichen',
    confirmPassword: 'Passwort bestätigen',
    confirmPasswordPlaceholder: 'Passwort erneut eingeben',
    creating: 'Wird erstellt...',
    createAccount: 'Konto erstellen',
    invalidTitle: 'Ungültige Einladung',
    invalidDescription: 'Diese Einladung ist ungültig, abgelaufen oder wurde bereits verwendet. Bitte wenden Sie sich an die einladende Person.',
    backToLogin: 'Zurück zur Anmeldung',
    welcome: 'Willkommen!',
    accountConfigured: 'Ihr Konto wurde eingerichtet.',
    accountReady: 'Konto bereit',
    pleaseSignIn: 'Melden Sie sich mit Ihrem neuen Passwort an.',
    sentInvitations: 'Gesendete Einladungen',
    statusAccepted: 'Angenommen',
    passwordSet: 'Passwort erstellt',
    emailAlreadyUsed: 'Diese Adresse gehört bereits zu einem Konto ({{company}} — {{role}}). Es wurde keine E-Mail gesendet.',
    invitationAlreadyPending: 'Für diese Adresse ist bereits eine Einladung offen ({{company}}). Es wurde keine E-Mail gesendet.',
    errors: {
      expired: 'Diese Einladung ist abgelaufen.',
      alreadyAccepted: 'Diese Einladung wurde bereits verwendet.',
      invalidToken: 'Ungültiger Einladungslink.',
      weakPassword: 'Das Passwort muss mindestens 8 Zeichen haben.',
      passwordMismatch: 'Die Passwörter stimmen nicht überein.',
      generic: 'Registrierung konnte nicht abgeschlossen werden. Bitte erneut versuchen oder Support kontaktieren.',
    },
  },
  adminInvitations: {
    actions: 'Aktionen',
    resend: 'Einladung erneut senden',
    resendSuccess: 'Einladung erneut gesendet',
    resendSuccessDescription: 'Eine neue E-Mail wurde an {{email}} gesendet.',
    resendError: 'Die Einladung konnte nicht erneut gesendet werden.',
    delete: 'Löschen',
    deleteTitle: 'Diese Einladung löschen?',
    deleteDescription: 'Der Einladungslink funktioniert sofort nicht mehr. Diese Aktion kann nicht rückgängig gemacht werden.',
    deleteSuccess: 'Einladung gelöscht',
    deleteError: 'Die Einladung konnte nicht gelöscht werden.',
    searchPlaceholder: 'Einladung suchen...',
    refresh: 'Aktualisieren',
    pageInfo: 'Seite {{page}} / {{total}} — {{count}} Einladung(en)',
    title: 'Gesendete Einladungen',
    empty: 'Noch keine Einladungen.',
    person: 'Person',
    email: 'E-Mail',
    company: 'Unternehmen',
    role: 'Rolle',
    sentAt: 'Gesendet am',
    expiresAt: 'Läuft ab am',
    status: 'Status',
    statuses: {
      pending: 'Offen',
      accepted: 'Angenommen',
      expired: 'Abgelaufen',
    },
  },
};
